import { render, staticRenderFns } from "./PublicTalentCard.vue?vue&type=template&id=a0a9cb6a&scoped=true&"
import script from "./PublicTalentCard.vue?vue&type=script&lang=js&"
export * from "./PublicTalentCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicTalentCard.vue?vue&type=style&index=0&id=a0a9cb6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a9cb6a",
  null
  
)

export default component.exports